import { render, staticRenderFns } from "./mai.vue?vue&type=template&id=d330c67c&scoped=true&"
import script from "./mai.vue?vue&type=script&lang=ts&"
export * from "./mai.vue?vue&type=script&lang=ts&"
import style0 from "./mai.vue?vue&type=style&index=0&id=d330c67c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d330c67c",
  null
  
)

export default component.exports